import {GridColumn, GridColumnGroupDef} from "@data/interefaces/data.interfaces";
import {ColumnFilterType} from "@data/enums/data.enums";

export let pageContext: {
  [key: string]: boolean | string | undefined
  p_f: string | undefined;
  s_f: string | undefined;
  t_f: string | undefined;
  a_f: string | undefined;
} = {
  p_f: undefined,
  s_f: undefined,
  t_f: undefined,
  a_f: undefined
};

export let tableColumns: (GridColumn | GridColumnGroupDef)[] = [
  {
    field: 'publisher',
    headerName: 'Publisher',
    hide: false,
    filter: ColumnFilterType.DROPDOWN,
    filterId: 'p_f',
    filterParams: {
      buttons: ['reset']
    }
  },
  {
    field: 'schema',
    headerName: 'Schema',
    hide: false,
    filter: ColumnFilterType.DROPDOWN,
    filterId: 's_f',
    filterParams: {
      buttons: ['reset']
    }
  },
  {
    field: 'table',
    headerName: 'Table',
    hide: false,
    filter: ColumnFilterType.DROPDOWN,
    filterId: 't_f',
    filterParams: {
      buttons: ['reset']
    }
  },
  {
    field: 'attributes',
    headerName: 'Columns',
    hide: false,
    filterId: 'a_f',
    filter: ColumnFilterType.DROPDOWN,
    wrapText: true,
    autoHeight: true,
    filterParams: {
      buttons: ['reset']
    },
    cellDataType: false, // removes warning from console - Please either provide an object data type definition with a Value Formatter, or set "colDef.valueFormatter
    cellRenderer: (params: { value: string[]; }) => `${params.value ? params.value.join(', ') : "-"}`,
  }
];
